import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
interface LanguageSwitcherProps {
  className?: string;
}
const languagePaths: Record<string, {
  de: string;
  en: string;
}> = {
  '/impressum': {
    de: '/impressum',
    en: '/en/imprint'
  },
  '/en/imprint': {
    de: '/impressum',
    en: '/en/imprint'
  },
  '/datenschutz': {
    de: '/datenschutz',
    en: '/en/privacy-policy'
  },
  '/en/privacy-policy': {
    de: '/datenschutz',
    en: '/en/privacy-policy'
  }
};
export function LanguageSwitcher({
  className = ''
}: LanguageSwitcherProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const paths = languagePaths[location.pathname];
  const currentLanguage = location.pathname.startsWith('/en/') ? 'en' : 'de';
  const handleLanguageChange = (language: 'de' | 'en') => {
    if (!paths || language === currentLanguage) return;
    navigate(paths[language]);
  };
  return <div className={`flex items-center gap-2 ${className}`} aria-label="Language selector" data-id="element-150">
      <GlobeIcon className="w-4 h-4 text-gray-400" aria-hidden="true" data-id="element-151" />
      <div className="flex items-center gap-1" data-id="element-152">
        <button type="button" onClick={() => handleLanguageChange('de')} aria-pressed={currentLanguage === 'de'} disabled={!paths} className={`px-1.5 py-1 text-sm font-medium transition-colors rounded ${currentLanguage === 'de' ? 'text-white' : 'text-gray-500 hover:text-gray-300'} ${!paths ? 'cursor-default' : ''}`} data-id="element-153">
          DE
        </button>
        <span className="text-gray-600" aria-hidden="true" data-id="element-154">
          |
        </span>
        <button type="button" onClick={() => handleLanguageChange('en')} aria-pressed={currentLanguage === 'en'} disabled={!paths} className={`px-1.5 py-1 text-sm font-medium transition-colors rounded ${currentLanguage === 'en' ? 'text-white' : 'text-gray-500 hover:text-gray-300'} ${!paths ? 'cursor-default' : ''}`} data-id="element-155">
          EN
        </button>
      </div>
    </div>;
}